import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "./apiURL";

export const fetchTenantConfig = createAsyncThunk(
  "tenant/fetchConfig",
  async (_, { rejectWithValue }) => {
    try {
      const res = await fetch(`${api}/api/v1/config`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token") || ""}`,
        },
      });
      const data = await res.json();
      return data.config;
    } catch (err) {
      return rejectWithValue(null);
    }
  }
);

const tenantSlice = createSlice({
  name: "tenant",
  initialState: {
    config: null,
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTenantConfig.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchTenantConfig.fulfilled, (state, action) => {
        state.config = action.payload;
        state.loading = false;
        if (action.payload) {
          applyTenantTheme(action.payload);
        }
      })
      .addCase(fetchTenantConfig.rejected, (state) => {
        state.loading = false;
      });
  },
});

const KNOWN_TEMPLATES = ["default", "apex", "mono", "grid", "muse"];

function applyTenantTheme(config) {
  const root = document.documentElement;
  if (config.primaryColor) root.style.setProperty("--tenant-primary", config.primaryColor);
  if (config.secondaryColor) root.style.setProperty("--tenant-secondary", config.secondaryColor);
  if (config.accentColor) root.style.setProperty("--tenant-accent", config.accentColor);
  if (config.name) document.title = config.name;

  // Toggle a `template-<id>` class on <html> so scoped theme stylesheets
  // (e.g. _apex-theme.scss) can override the default Apple-style skin only
  // for tenants who picked that template - everyone else keeps today's UI.
  root.classList.remove(...KNOWN_TEMPLATES.map((t) => `template-${t}`));
  root.classList.add(`template-${config.templateId || "default"}`);
  // Only uploaded logos become the favicon - placeholder junk from tenant
  // creation (e.g. via.placeholder.com) would show a broken/foreign icon.
  if (config.logo && !config.logo.includes("placeholder.com")) {
    const favicon = document.querySelector("link[rel~='icon']");
    if (favicon) favicon.href = config.logo;
  }
}

export default tenantSlice.reducer;
